import _ from "lodash";
import React from "react";
import ReactTooltip from "react-tooltip";

import images from "../../../utils/images";

import "./style.scss";

const showX = (toolTipRef, doNotShowX) => {
  if (doNotShowX) {
    return <></>;
  }

  return (
    <img
      alt="X"
      className="close-tooltip"
      onClick={() => {
        ReactTooltip.hide(toolTipRef);
      }}
      role="button"
      src={images("./icons/x-gry.png")}
    />
  );
};

const InputToolTip = (props) => {
  const { onKeyDown } = props;
  const toolTipId = props.id + "-tooltip";

  let toolTipRef = React.createRef();

  return (
    <>
      <input onKeyDown={onKeyDown} {...props.field} {...props} id={props.id} />
      <img
        alt="i"
        className="tooltip-btn text-center tw:font-bold"
        data-for={toolTipId}
        data-tip="tooltip"
        onClick={() => {
          ReactTooltip.show(toolTipRef);
        }}
        ref={(ref) => (toolTipRef = ref)}
        role="button"
        src={images("./icons/info.png")}
      />
      <ReactTooltip
        backgroundColor="white"
        border={true}
        borderColor="#5B57DC !important"
        className={_.get(props, "elementConfig.tooltipClass", "")}
        effect="solid"
        id={toolTipId}
        place="left"
        textColor="black"
      >
        {showX(toolTipRef, props.elementConfig.doNotShowX)}
        {props.elementConfig.tooltipContents}
      </ReactTooltip>
    </>
  );
};

export default InputToolTip;
